/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'form-label';

/**
 * This is the component description.
 */
const Label = ({
  id,
  className: userClassName,
  style,
  children,
  name,
  color,
  optional,
  as: Wrapper
  // ...otherProps
}) => /*#__PURE__*/React.createElement(Wrapper, {
  htmlFor: Wrapper === 'label' ? name : undefined,
  id: id,
  className: [baseClassName, componentClassName, userClassName, `x-${color}`].filter(e => e).join(' '),
  style: style
}, children, optional && ' (Optional)');
Label.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   *  The name of the input label
   */
  name: PropTypes.string,
  /**
   *  The html tag that acts as an input label
   */
  as: PropTypes.node,
  /**
   *  The default color of the label
   */
  color: PropTypes.string,
  /**
   * Whether the input should have an optional tag
   */
  optional: PropTypes.bool
};
Label.defaultProps = {
  as: 'label',
  color: 'paragraph',
  optional: false
};
export default Label;